import type { CSDashboardState } from '~/common/models/csDashboard.model';

import { csDashboardAdapter } from './csDashboardSlice.adapters';

export const INITIAL_CS_DASHBOARD_STATE =
  csDashboardAdapter.getInitialState<CSDashboardState>({
    sessionConfigs: {},
    operations: {},
  });
